module.exports = __webpack_public_path__ + "static/media/img-goal-14.7c1ad5d4.jpg";